import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';

import history from 'browserHistory';
import SnackbarNotificationContainer from 'components/Snackbars/SnackbarNotificationContainer';
import { AuthProvider } from 'contexts/AuthContext';
import MaterialProvider from 'contexts/MaterialProvider';
import { ResponsiveProvider } from 'contexts/ResponsiveContext';
import { StyledThemeProvider } from 'contexts/StyledThemeProvider';
import store from 'reduxStore/store';
import AppRoutes from 'router/AppRoutes';
import Router from 'router/Router';

import GlobalStyle from './GlobalStyle';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <SnackbarNotificationContainer />
        <AuthProvider>
          <ResponsiveProvider>
            <MaterialProvider>
              <StyledThemeProvider>
                <Router history={history}>
                  <GlobalStyle />
                  <AppRoutes />
                </Router>
              </StyledThemeProvider>
            </MaterialProvider>
          </ResponsiveProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
